// Shared navigation links configuration
// This centralizes all navigation items to reduce maintenance when adding new links.
// Labels are catalog keys (src/locales/en-US/common.json), resolved with t() at
// render time so the menus follow the active locale (ENG-387).
export const navigationLinks = [
  {
    id: 'performers',
    labelKey: 'navigation.links.performers',
    path: '/performers',
    showInMainNav: true,
    showInHamburgerMenu: true
  },
  {
    id: 'history',
    labelKey: 'navigation.links.history',
    path: '/history',
    showInMainNav: true,
    showInHamburgerMenu: true
  },
  {
    id: 'achievements',
    labelKey: 'navigation.links.achievements',
    path: '/achievements',
    showInMainNav: true,
    showInHamburgerMenu: true
  },
  {
    // The skins shop (ENG-823). The headers link it directly (ENG-864):
    // StreamPageHeader and its AccountMenu for listeners, TopPageNavigationBand
    // for performers. MainNavigation still reads this list, so it shows there too.
    id: 'shop',
    labelKey: 'navigation.links.shop',
    path: '/shop',
    showInMainNav: true,
    showInHamburgerMenu: true
  },
  {
    id: 'profile',
    labelKey: 'navigation.links.profile',
    path: '/profile',
    showInMainNav: true,
    showInHamburgerMenu: true,
    requiresProfileImage: true // Special handling for profile image
  }
  // Future links can be uncommented and added here
  /*
  {
    id: 'community',
    label: 'Community',
    icon: RiCommunityLine,
    path: '/community',
    showInMainNav: true,
    showInHamburgerMenu: true
  },
  {
    id: 'connections',
    label: 'Connections',
    icon: FaUsersCog,
    path: '/connections',
    showInMainNav: true,
    showInHamburgerMenu: true
  },
  {
    id: 'nearby',
    label: 'Nearby',
    icon: FaMapMarkerAlt,
    path: '/nearby',
    showInMainNav: true,
    showInHamburgerMenu: true
  },
  {
    id: 'songs',
    label: 'Songs',
    icon: FaMusic,
    path: '/songs',
    showInMainNav: true,
    showInHamburgerMenu: true
  },
  {
    id: 'learn',
    label: 'Learn',
    icon: FaBook,
    path: '/learn',
    showInMainNav: true,
    showInHamburgerMenu: true
  }
  */
];

// Band-specific navigation links for song list page
export const bandSongListNavigationLinks = [
  {
    id: 'add-song',
    labelKey: 'navigation.links.addSong',
    path: '/performers/:bandid/add-song',
    showInMainNav: false,
    showInHamburgerMenu: true,
    bandSpecific: true
  },
  {
    id: 'import-songlist',
    labelKey: 'navigation.links.importSonglist',
    path: '#import-songlist',
    showInMainNav: false,
    showInHamburgerMenu: true,
    bandSpecific: true,
    isAction: true
  },
  {
    id: 'edit-tags',
    labelKey: 'navigation.links.editTags',
    path: '/performers/:bandid/edit-tags',
    showInMainNav: false,
    showInHamburgerMenu: true,
    bandSpecific: true
  },
  {
    id: 'band-settings',
    labelKey: 'navigation.links.bandSettings',
    // Band settings are views of the band page, which have no URL of their
    // own; router state tells the page to open this one (ENG-513). The
    // /settings route this used to point at never existed.
    path: '/performers/:bandid',
    state: { openView: 'band-settings' },
    showInMainNav: false,
    showInHamburgerMenu: true,
    bandSpecific: true
  }
];

// Band-specific navigation links for events page
export const bandEventsNavigationLinks = [
  {
    id: 'add-event',
    labelKey: 'navigation.links.addEvent',
    path: '#add-event',
    showInMainNav: false,
    showInHamburgerMenu: true,
    bandSpecific: true,
    isAction: true
  }
];

// Helper functions to filter links
export const getMainNavigationLinks = () => 
  navigationLinks.filter(link => link.showInMainNav);

export const getHamburgerMenuLinks = () => 
  navigationLinks.filter(link => link.showInHamburgerMenu);

export const getBandSongListHamburgerMenuLinks = () => 
  bandSongListNavigationLinks.filter(link => link.showInHamburgerMenu);

export const getBandEventsHamburgerMenuLinks = () => 
  bandEventsNavigationLinks.filter(link => link.showInHamburgerMenu);